import React from "react";

// import AddIcon from "@mui/icons-material/Add";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DeleteIcon from "@mui/icons-material/Delete";
// import DownloadIcon from "@mui/icons-material/Download";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import SaveIcon from "@mui/icons-material/Save";
import TodayOutlinedIcon from "@mui/icons-material/TodayOutlined";
import { Box, CircularProgress, IconButton, TextField } from "@mui/material";
import Typography from "@mui/material/Typography";
import { SelectDateRange } from "components/forms";
import { SelectCurrency } from "components/reports/Select-currency/SelectCurrency";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import { DateRangeValue, DateRangeValueType } from "store/types";

interface ToolbarProps {
  reportTitle: string;
  dateRange: DateRangeValue;
  currentPageIndex: number;
  pagesCount: number;
  // loading: boolean;
  // exporting: boolean;
  hasContent: boolean;
  savingTemplate?: boolean;
  currentTemplateName?: string;
  onTitleChange: (title: string) => void;
  onDateRangeChange: (data: DateRangeValue & { value: DateRangeValueType }, useAccountingDate?: boolean) => void;
  onPrevPage: () => void;
  onNextPage: () => void;
  onAddPage: () => void;
  onRemovePage: () => void;
  // onExportPdf: () => void;
  onSaveTemplate?: () => void;
  onLoadTemplate?: () => void;
}

export const Toolbar: React.FC<ToolbarProps> = ({
  reportTitle,
  dateRange,
  currentPageIndex,
  pagesCount,
  // loading,
  // exporting,
  hasContent,
  savingTemplate,
  currentTemplateName,
  onTitleChange,
  onDateRangeChange,
  onPrevPage,
  onNextPage,
  // onAddPage,
  onRemovePage,
  // onExportPdf,
  onSaveTemplate,
  onLoadTemplate
}) => {
  return (
    <Box
      sx={{
        p: "12px",
        boxShadow: "0 1px 2px 0 #1212171a",
        display: "flex",
        alignItems: "center",
        gap: "16px",
        backgroundColor: "white",
        borderRadius: "8px"
      }}
    >
      <TextField
        value={reportTitle}
        onChange={(e) => onTitleChange(e.target.value)}
        variant="outlined"
        size="small"
        label="Report Title"
        sx={{ width: 300 }}
        placeholder="Report Title"
      />
      {/* Date Range Selector */}
      <SelectDateRange
        formControlProps={{ sx: { minWidth: "200px" } }}
        selectProps={{
          startAdornment: <TodayOutlinedIcon sx={{ fontSize: "15px" }} />
        }}
        label=""
        value={dateRange}
        onChange={onDateRangeChange}
      />
      <SelectCurrency />
      {/* Template actions */}
      {onLoadTemplate && (
        <MaterialTooltip isShow title="Load template">
          <IconButton onClick={onLoadTemplate} size="sm">
            <FolderOpenIcon />
          </IconButton>
        </MaterialTooltip>
      )}
      {onSaveTemplate && (
        <MaterialTooltip
          isShow
          title={currentTemplateName ? `Save Template: ${currentTemplateName}` : "Save as template"}
        >
          <IconButton onClick={onSaveTemplate} disabled={savingTemplate || !hasContent} size="sm">
            {savingTemplate ? <CircularProgress size={18} /> : <SaveIcon />}
          </IconButton>
        </MaterialTooltip>
      )}
      <Box sx={{ flex: 1 }} />
      {/* Page navigation */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <IconButton size="sm" disabled={currentPageIndex === 0} onClick={onPrevPage}>
          <ChevronLeftIcon />
        </IconButton>
        <Typography variant="body2">
          Page {currentPageIndex + 1} of {pagesCount}
        </Typography>
        <IconButton size="sm" disabled={currentPageIndex === pagesCount - 1} onClick={onNextPage}>
          <ChevronRightIcon />
        </IconButton>
        {/* <MaterialTooltip isShow title="Add page">
          <IconButton size="sm" onClick={onAddPage}>
            <AddIcon />
          </IconButton>
        </MaterialTooltip> */}
        {pagesCount > 1 && (
          <MaterialTooltip isShow title="Remove current page">
            <IconButton size="sm" onClick={onRemovePage} color="error">
              <DeleteIcon />
            </IconButton>
          </MaterialTooltip>
        )}
      </Box>
      {/* <Button
        variant="contained"
        startIcon={exporting ? <CircularProgress size={18} color="inherit" /> : <DownloadIcon />}
        disabled={loading || exporting || !hasContent}
        onClick={onExportPdf}
      >
        {exporting ? "Exporting..." : "Export PDF"}
      </Button> */}
    </Box>
  );
};
